import { Injectable } from '@angular/core';
import { ApiAuthService } from './api-auth.service';
import { ToTypeOrm } from '../models/_to-type-orm.schema';

@Injectable({
  providedIn: 'root'
})
export class ValetPriorityListService extends ApiAuthService {
  private readonly url = `${this.baseUrl}/expert-priority`;

  async getAllValetPriorityLists(page?: number, limit?: number, order?: {}, filter: any = {}): Promise<any> {
    return this.getAll(page, limit, order, filter);
  }

  async getAll(page?: number, limit?: number, order?: {}, filter?: { [key: string]: ToTypeOrm }): Promise<any>{
    let params = {};
    if (page) params['page'] = page;
    if (limit) params['limit'] = limit;
    if (order) params['order'] = JSON.stringify(order);
    if (filter) params['filter'] = JSON.stringify(filter);
    return this.request(() => this.http.get(`${this.url}`, { params: params }).toPromise() );
  }

  async createExpertPriorityList(formData: any): Promise<any> {
    return this.request(() => this.http.post(`${this.url}`, formData).toPromise());
  }

  async updateExpertPriorityList(priorityId: number, formData: any): Promise<any>{
    return this.request(() => this.http.put(`${this.url}/${priorityId}`, formData ).toPromise() );
  }

  async getExpertPriorityList(id: number): Promise<any> {
    return this.request(() => this.http.get(`${this.url}/${id}`).toPromise());
  }

  async deleteValetListService(priorityId: number): Promise<any>{
    return this.request(() => this.http.delete(`${this.url}/${priorityId}` ).toPromise() );
  }

}
